(function () {
    'use strict';

    angular
        .module('surveyCampaignsModule')
        .controller('SurveyCampaignInviteDetailsEditController', Controller);

    Controller.$inject = ['$scope', '$state', 'businessUnit', 'campaign'];

    function Controller($scope, $state, businessUnit, campaign) {
        $scope.businessUnit = businessUnit;
        $scope.campaign = campaign;

        if (campaign && campaign.ODDInviteDetails && campaign.ODDInviteDetails.length > 0) {
            $scope.inviteDetails = campaign.ODDInviteDetails[0];
        }
        else {
            $scope.inviteDetails = null;
        }
        $scope.goToCampaign = function () {
            $state.go('odd.surveyCampaignEdit', { ODDCampaignID: campaign.ODDCampaignID });
        };

        $scope.goToCampaigns = function () {
            $state.go('odd.surveyCampaigns', { ODDBusinessUnitID: $scope.campaign.ODDBusinessUnitID }, { reload: true });
        };

    }
})();